var PATH_PREFIX_BLACKLIST = ['/nl', '/de'];
// Currently we have different definitions of multi-language regions URLS.
// For some cases even if language is a default we need to include path prefix,
// for other cases we need to remove them.
// Locale provides currently always adds path prefix for multi-languages regions.
// This method removes redundant default languages URLs prefixing.
export var getUrlPrefix = function (pathPrefix, isCurrent) {
    return isCurrent
        ? '#'
        : PATH_PREFIX_BLACKLIST.includes(pathPrefix)
            ? '/'
            : pathPrefix + "/";
};
export var getCurrentUrl = function () {
    return typeof window === 'undefined' ? '' : window.location.href;
};
export var getUrlWithQueryParams = function (values, baseUrl) {
    var urlToParse = baseUrl || getCurrentUrl();
    if (!urlToParse) {
        return '';
    }
    var url = new URL(urlToParse);
    Object.keys(values).forEach(function (key) {
        if (values[key] !== '') {
            url.searchParams.set(key, values[key]);
        }
        else {
            url.searchParams.delete(key);
        }
    });
    return url.href;
};
export var getUrlWithoutQueryParams = function (keys, baseUrl) {
    var urlToParse = baseUrl || getCurrentUrl();
    if (!urlToParse) {
        return '';
    }
    var url = new URL(urlToParse);
    keys.forEach(function (key) {
        url.searchParams.delete(key);
    });
    return url.href;
};
export var updateUrl = function (url) {
    if (window && window.history) {
        window.history.replaceState(null, '', url);
    }
};
